module.exports = __webpack_public_path__ + "img/team_03.5339cd8d.jpg";